// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PrivacyPolicy-module--content-container--E51Aq","textContainer":"PrivacyPolicy-module--text-container--gQgsH"};